var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BCXMarkdown,{staticClass:"c-data-notice",style:({
    '--markdown-font-size': _vm.fontSize,
    '--markdown-line-height': _vm.lineHeight
  }),attrs:{"tag":"div","text":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }